import { useInfiniteQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { getNextPageParam } from '@pkg/hooks';

import { callGetCollectionUserAssets } from '@app/client/resources/yat-pages/page-items';
import { PathParams } from '@app/routes/types';

import { useNFTMainOwnerData } from './useNFTMainOwnerData';

export const useGetCollectionOwnerAssets = (enabled = true) => {
    const { owner } = useNFTMainOwnerData();
    const { [PathParams.Contract]: contract } = useParams();
    const ownerId = owner?.id || '';
    const cache = ['ownerCollectionAssets', ownerId, contract];

    return useInfiniteQuery(
        cache,
        ({ signal }) =>
            callGetCollectionUserAssets({
                contract: contract || '',
                ownerId,
                query: { limit: 10 },
                settings: {
                    signal,
                },
            }),
        {
            retry: false,
            enabled: Boolean(ownerId && contract && enabled),
            getNextPageParam,
        },
    );
};
